export default {
  authenticated: false,
  originalToken: null,
  token: null,
  entitlements: null,
  role: null,
  companyId: null,
  server: null,
  login: null,
  mckidToken: null,
  mckidExpDate: null,
  mckidRefreshToken: null
}
